import React from 'react';
import ListItemPerson from '../AbstractComboBox/ListItemPerson/ListItemPerson';
import SingleSelectComboBox, { SingleSelectComboBoxProps } from '../AbstractComboBox/SingleSelectComboBox';
import getUserTopResults from './getUserTopResults';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';
import { useHtmlValidId } from '../../../../../../hooks/useHtmlValidId';

type UserSingleSelectComboBoxProps = SingleSelectComboBoxProps & {
  onChange?: (item?: TopUserResult) => void;
};

export default function UserSingleSelectComboBox(props: UserSingleSelectComboBoxProps) {
  return (
    <SingleSelectComboBox
      {...props}
      responseMapper={getUserTopResults}
      inputValueSelector={item => item.profileNameWithoutHighlighting}
    >
      {item => <ListItemPerson user={item} withEmail />}
    </SingleSelectComboBox>
  );
}

/**
 * Form2 compatible UserSingleSelectComboBox
 * onChange not needed as Form2 relies on HTML konform data.
 * */
export function UserSingleSelectComboBoxForm2(props: Omit<UserSingleSelectComboBoxProps, 'name' | 'id'>) {
  const id = useHtmlValidId();
  return (
    <SingleSelectComboBox
      {...props}
      id={`user-single-select-combobox-${id}`}
      name={undefined}
      responseMapper={getUserTopResults}
      inputValueSelector={item => item.profileNameWithoutHighlighting}
    >
      {item => <ListItemPerson user={item} withEmail />}
    </SingleSelectComboBox>
  );
}
